'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';

export default function WatchlistButton({ seriesId, seriesSlug }: { seriesId: number; seriesSlug: string }) {
  const router = useRouter();
  const [loading, setLoading] = useState(true);
  const [inList, setInList] = useState(false);

  useEffect(() => {
    fetch('/api/auth/me')
      .then((r) => r.json())
      .then((d) => {
        if (!d.user) {
          setLoading(false);
          return;
        }
        fetch('/api/watchlist')
          .then((r) => r.json())
          .then((w) => {
            setInList(w.watchlist?.some((s: any) => s.id === seriesId) ?? false);
            setLoading(false);
          })
          .catch(() => setLoading(false));
      })
      .catch(() => setLoading(false));
  }, [seriesId]);

  const toggle = async () => {
    const me = await fetch('/api/auth/me').then((r) => r.json());
    if (!me.user) {
      router.push(`/login?next=/anime/${seriesSlug}`);
      return;
    }
    const res = await fetch('/api/watchlist', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ seriesId, action: inList ? 'remove' : 'add' }),
    });
    const data = await res.json();
    setInList(data.inWatchlist);
  };

  if (loading) {
    return (
      <button disabled className="px-4 py-2 rounded-lg bg-zinc-800 text-zinc-500 text-sm">
        …
      </button>
    );
  }

  return (
    <button
      onClick={toggle}
      className={`px-4 py-2 rounded-lg text-sm font-semibold transition border ${
        inList
          ? 'bg-violet-600/20 text-violet-300 border-violet-600/50 hover:bg-violet-600/30'
          : 'bg-zinc-800 text-zinc-200 border-zinc-700 hover:bg-zinc-700'
      }`}
    >
      {inList ? '★ In Watchlist' : '☆ Add to Watchlist'}
    </button>
  );
}
